module.exports = __webpack_public_path__ + "img/zhga-3.2573f2cf.png";